import { render, staticRenderFns } from "./TagDsp.vue?vue&type=template&id=e925a4c8"
import script from "./TagDsp.vue?vue&type=script&lang=js"
export * from "./TagDsp.vue?vue&type=script&lang=js"
import style0 from "./TagDsp.vue?vue&type=style&index=0&id=e925a4c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports